module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Watch1-bff0110ed0eeca44db649dc6b683f219.svg";